import classes from './LoadingScreen.module.css';

type LoadingScreenProps = {
  message: string;
};

function LoadingScreen({ message }: LoadingScreenProps): JSX.Element {
  return (
    <div className={classes.container}>
      <p>{message}</p>
    </div>
  );
}

export default LoadingScreen;
